import { render, staticRenderFns } from "./customersTable.vue?vue&type=template&id=0f29ecc4&scoped=true&"
import script from "./customersTable.vue?vue&type=script&lang=js&"
export * from "./customersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29ecc4",
  null
  
)

export default component.exports